export default "__VITE_ASSET__c89aba30__"